<template>
	<div class="main-content">
		<slot>
			<p>There is currently no content specified</p>
		</slot>
	</div>
</template>

<script>
	export default {
		name: 'Content'
	}
</script>

<style lang="scss">
	@import '@/assets/scss/_variables.scss';

	$content-width: 800px;

	.main-content {
		font-family: $font-sans;
		font-size: 1.4rem;
		line-height: 1.2;
		margin: 0 auto;
		max-width: $content-width;

		section {
			margin-bottom: 60px;

			&:last-child {
				margin-bottom: 0;
			}
		}

		h2 {
			color: $color-y;
			font-family: $font-serif;
			font-size: 1.8rem;
			margin-bottom: 10px;
		}

		h3 {
			color: $color-y;
			font-size: 1.5rem;
			margin-bottom: 10px;
		}

		h4 {
			color: $color-b;
			font-size: 1.3rem;
			margin-bottom: 10px;
		}

		p {
			margin-bottom: 20px;
		}

		a {
			color: $color-b;
		}

		em {
			font-style: italic;
		}

		li {
			font-size: 1.3rem;
			line-height: 1.4;
			list-style: square;
			margin-left: 20px;
			padding-left: 5px;
		}

		* + h2 {
			margin-top: 40px;
		}

		* + h3 {
			margin-top: 30px;
		}

		* + h4 {
			margin-top: 20px;
		}

		ul {
			margin-bottom: 15px;
		}

		pre {
			margin-bottom: 15px;
		}

		code {
			background-color: #313131;
			color: #b7b7b7;
			display: inline-block;
			padding: 0 10px;
		}

		.big-title {
			font-size: 2.5rem;
			text-align: center;
		}

		// CTA Button
		// @TODO: Make generic
		.download {
			text-align: center;
			margin: 100px auto 0;

			h2 {
				font-size: 1.8rem;
			}

			p {
				font-size: 1.6rem;
			}
		}

		table {
			margin-bottom: 20px;

			thead {
				tr {
					background-color: #111;
				}
			}

			tr:nth-of-type(even) {
				background-color: #282828;
				opacity: .8;
			}

			tr:nth-of-type(odd) {
				td {
					// opacity: .8;
				}
			}

			th {
				text-align: left;
				color: $color-or;
			}

			th, td {
				padding: 6px 15px;
				line-height: 1.1;
			}
		}
	}

	// Wideout: breaks out of max content width
	$wideout-width: $content-width + 600px;
	$wideout-negative-indent: -($wideout-width - $content-width) / 2;

	@media (min-width: $wideout-width) {
		.wideout {
			margin-left: $wideout-negative-indent;
			width: $wideout-width;
		}
	}
</style>
